import { useState, useEffect } from "react";
import { Box, Checkbox, FormControl, FormControlLabel } from "@mui/material";
import {
  getMovementTypeName,
  MovementTypeEnum,
} from "../../../common/EntitiesManagement";
import AddOrEditBasicEntity from "../../../components/common/AddOrEditBasicEntity";
import Combobox from "../../../components/common/Combobox";
import localize from "../../../common/localize";
import PageTitleSubtitle from "../../../components/PageTitleSubTitle";
import NotificationSetup from "../../../components/common/NotificationSetup";
import ExpandableView from "../../../components/common/ExpandableView";

export default function AddOrEditInventoryMovementType({ model, setModel }) {
  const [selectedMovementType, setSelectedMovementType] = useState({
    Id: model.MovementType,
    Name: getMovementTypeName(model.MovementType),
  });

  const getMovementTypes = () => [
    {
      Id: MovementTypeEnum.In,
      Name: getMovementTypeName(MovementTypeEnum.In),
    },
    {
      Id: MovementTypeEnum.Out,
      Name: getMovementTypeName(MovementTypeEnum.Out),
    },
  ];

  const handleSelectedMovementType = (value) => {
    if (!value) {
      setSelectedMovementType({
        Id: MovementTypeEnum.In,
        Name: getMovementTypeName(MovementTypeEnum.In),
      });
      return;
    }

    setSelectedMovementType({
      Id: value.Id,
      Name: value.Name,
    });
  };

  useEffect(() => {
    if (!!selectedMovementType) {
      setModel({
        ...model,
        MovementType: selectedMovementType.Id,
      });
    }
  }, [selectedMovementType]);

  const handleCheckedChanged = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.checked,
    });
  };

  return (
    <Box className="w-full">
      <ExpandableView
        components={[
          {
            Name: localize.general_information,
            Component: (
              <AddOrEditBasicEntity
                customWidth="100%"
                model={model}
                setModel={setModel}
                customComponent={
                  <Box className="flex flex-col gap-2 my-2">
                    <FormControl required fullWidth>
                      <Combobox
                        id="MovementType"
                        fieldLabel={localize.movement_type}
                        fieldOptions={getMovementTypes()}
                        fieldValue={selectedMovementType}
                        handleValueChange={handleSelectedMovementType}
                      />
                    </FormControl>

                    <FormControlLabel
                      size="small"
                      name="referencedByUsage"
                      control={
                        <Checkbox
                          size="small"
                          name="referencedByUsage"
                          checked={model.referencedByUsage}
                          onChange={handleCheckedChanged}
                        />
                      }
                      label={
                        <span style={{ fontSize: "0.8em" }}>
                          <PageTitleSubtitle
                            title={localize.referenced_by_usage}
                            subtitle={localize.referenced_by_usage_note}
                            useEventTitleStyle
                            useFieldTitleStyle
                          />
                        </span>
                      }
                    />
                  </Box>
                }
                customComponentAtTop
              />
            ),
          },
          {
            Name: localize.notification,
            Component: (
              <NotificationSetup
                showOnlyDefinedToUser
                entity={model}
                setEntity={setModel}
                subtitle={localize.notify_inventory_movement_type}
              />
            ),
          },
        ]}
      />
    </Box>
  );
}
